// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.
import { Application } from "@hotwired/stimulus"
import { registerControllers } from "../utils/stimulus_loader"

const application = Application.start()

// Load all controllers except the ones marked for lazy loading
const controllers = import.meta.glob('./**/*_controller.js', { eager: true })

registerControllers(application, controllers, { excludeLazy: true })
